// https://developers.google.com/analytics/devguides/collection/analyticsjs/sending-hits?hl=ja#handling_timeouts
const makeFailSafe = (callback, timeout = 1000) => {
  let called = false;
  const fn = () => {
    if (!called) {
      called = true;
      callback();
    }
  }
  setTimeout(fn, timeout);
  return fn;
}

export default makeFailSafe;
